import React from 'react';
import css from './css/QuestionOptionsTable.scss';
import commonCss from './css/SurveyStyle.scss';
import Icon from 'SF/MaterialIcon';
import SortableTable from 'SF/table/SortableTable';
import ReactTooltip from 'react-tooltip';
import { Table } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { sortBy } from 'lodash';

const headers = [
    {
        content: 'Option',
        width: 12
    }, {
        content: 'Actions',
        width: 2
    }
];

const QuestionOptionsTable = ({editable, options, editOption, deleteOption}) => {
    const getActionButtons = (option) => (
        <>
            <button type='button' aria-label={`Edit ${option.text} Option`} onClick={() => editOption(option)}>
                <Icon icon='edit' aria-hidden /></button>
            <button type='button' aria-label={`Delete ${option.text} Option`} onClick={() => deleteOption(option)}>
                <Icon icon='cancel' aria-hidden /></button>
        </>
    );

    const getLockedButton = () => (
        <>
            <Icon icon='lock' data-tip data-for='lock-tip' className={css['lock-icon']} aria-hidden />
            <ReactTooltip id='lock-tip' className={commonCss['tooltip']} place='bottom' effect='solid'>
                No longer editable
            </ReactTooltip>
        </>
    );

    const renderRow = (option, index) => (
        <Table.Row key={index} data-testid={`optionRow-${index}`}>
            <Table.Cell>{option.text}</Table.Cell>
            <Table.Cell className={css['icon-container']}>
                {editable ? getActionButtons(option) : getLockedButton()}
            </Table.Cell>
        </Table.Row>
    );

    return (
        <SortableTable
            className={commonCss['table']}
            headers={headers}
            columnToSort=''
            itemName='options'
            items={sortBy(options, 'position')}
            renderItem={renderRow}
            shouldPaginate={false}
            celled
        />
    );
};

QuestionOptionsTable.propTypes = {
    editable: PropTypes.bool.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
        text: PropTypes.string.isRequired,
        position: PropTypes.number.isRequired
    })).isRequired,
    editOption: PropTypes.func.isRequired,
    deleteOption: PropTypes.func.isRequired
};

export default QuestionOptionsTable;
